import { useState } from "react";
import { Link } from "react-router-dom";
import AnimeCard from "@/components/base/AnimeCard";
import { animeList } from "@/mocks/anime";

const tabs = [
  { key: "hot", label: "热门" },
  { key: "new", label: "最新" },
  { key: "rating", label: "高分" },
  { key: "ongoing", label: "连载中" },
];

export default function HotList() {
  const [active, setActive] = useState("hot");

  let list = [...animeList];
  if (active === "hot") {
    list = list.filter((a) => !isNaN(parseFloat(a.views)));
    list.sort((a, b) => parseFloat(b.views) - parseFloat(a.views));
  } else if (active === "new") {
    list = list.sort((a, b) => b.year - a.year);
  } else if (active === "rating") {
    list = list.sort((a, b) => b.rating - a.rating);
  } else if (active === "ongoing") {
    list = list.filter((a) => a.status === "连载中");
  }

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-sm text-accent-600 font-medium inline-flex items-center gap-2">
              <i className="ri-fire-line"></i>
              精选推荐
            </p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">
              大家都在看的奇幻番剧
            </h2>
          </div>

          <div className="inline-flex items-center gap-1 p-1 bg-background-50 rounded-full border border-background-200 self-start md:self-auto">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  active === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {list.slice(0, 8).map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/fairy"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-700 hover:bg-primary-500 hover:text-background-50 text-sm font-medium transition-colors"
          >
            浏览全部番剧 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}